module.exports = {
  production: false,
  protocol: "https",
  host: "0.0.0.0",
  port: "80",
  api: "https://38quddlk07.execute-api.eu-west-1.amazonaws.com/staging",
  authUrl: "https://uunn-backoffice.auth.eu-west-1.amazoncognito.com/login?response_type=token&client_id=20glkgf3q35l047udeili4mpjv&redirect_uri=https://d1xpvpcfcwf2br.cloudfront.net/login",
  logoutUrl: "https://uunn-backoffice.auth.eu-west-1.amazoncognito.com/logout?client_id=20glkgf3q35l047udeili4mpjv&logout_uri=https://d1xpvpcfcwf2br.cloudfront.net/login"
};
